import { enableProdMode } from '@angular/core';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from './environments/environment';
import { appConfig } from './app-config';

if (environment.production) {
  enableProdMode();
}

const companyIdFromUrl = new URLSearchParams(window.location.search).get('companyId');
if (companyIdFromUrl) {
  sessionStorage.setItem('companyId', companyIdFromUrl);
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
